import JobCategoriesSection from "@/components/job-board/job-categories-section";
import type { FunctionalAreaFacet } from "@/lib/job-board/types";

type Props = {
  functionalArea?: FunctionalAreaFacet[];
  initialError?: boolean;
};

export default function FunctionalAreaTable({ functionalArea, initialError = false }: Props) {
  return <JobCategoriesSection initialFacets={functionalArea} initialError={initialError} />;
}
